export const enum VatAccountingInterval {
  YEAR = 'YEAR',
  QUARTER = 'QUARTER',
  MONTH = 'MONTH',
  NONE = 'NONE',
}
